const data = {
  "recentlyViewed": {
    "sectionTitle": "Eerder bekeken door jou",
    "productCard": {
      "formerPricePrefix": "Adviesprijs"
    },
    "logIn": {
      "emptyTitle": "Jouw producten overal beschikbaar",
      "defaultTitle": "Mis je een product?",
      "emptyDescription": "Log in om jouw eerder bekeken producten te zien.",
      "defaultDescription": "Log in om al jouw eerder bekeken producten te zien.",
      "action": "Inloggen"
    }
  }
};

export default data;